import { render, staticRenderFns } from "./soorderrate.vue?vue&type=template&id=149ff65f&scoped=true&"
import script from "./soorderrate.vue?vue&type=script&lang=js&"
export * from "./soorderrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ff65f",
  null
  
)

export default component.exports